import { inject, Injectable } from '@angular/core';
import { BoardResolutionApprovingPersonsModelKeys, BoardResolutionModelKeys } from '../const/form-field-key.const';
import { PortalFieldConfig } from '@portal/form/data-access';
import { combineLatest, map, tap } from 'rxjs';
import { ApplicationStore, BoardResolutionFileStore, FinancialRequiredStore } from '../store';
import { Helper } from '@portal/util';
import { UploadFileModel } from '@portal/upload-file/data-access';
import { PersonnelAppointment } from '@core/data-access';

@Injectable({ providedIn: 'root' })
export class BoardResolutionFormConfigService {
  private readonly financialRequiredStore = inject(FinancialRequiredStore);
  private readonly applicationStore = inject(ApplicationStore);
  private readonly boardResolutionFileStore = inject(BoardResolutionFileStore);
  readonly authorizedSignatoryOptions$ = this.financialRequiredStore.portalPersonnelOptionsMap$.pipe(
    map(optionsMap =>
      Array.from(optionsMap.values()).filter(option => option.personnel?.appointment?.includes(PersonnelAppointment.AUTHORISED_SIGNATORY)),
    ),
  );

  initBoardResolutionFormFields(): PortalFieldConfig[] {
    return [
      {
        key: BoardResolutionModelKeys.attachment,
        type: 'form-review-board-resolution',
        hooks: {
          onInit: field => {
            return combineLatest([this.applicationStore.soleProprietorship$, this.boardResolutionFileStore.dataState$]).pipe(
              tap(([isSoleProprietor, state]) => {
                const file = state?.data;
                if (!isSoleProprietor && file) {
                  const id = Helper.randomId(4);
                  field?.model.attachment.set(id, UploadFileModel.fromJson({ id, file, fileName: file.name }));
                }
              }),
            );
          },
        },
      },
      {
        key: BoardResolutionModelKeys.isReviewedBoardResolution,
        type: '#yesNo',
        props: { required: true },
        expressions: { hide: 'formState.hideSignatureBoardResolution' },
      },
      {
        fieldGroup: [
          {
            key: BoardResolutionModelKeys.mode,
            type: '#boardResolutionMode',
            props: {
              label: 'How many approving persons are needed to approve an action?',
              required: true,
              hint: 'Please select either 2 directors or 1 director and 1 secretary to sign the board resolution.',
            },
            expressions: { hide: 'formState.hideApprovingPersons' },
          },
          {
            key: BoardResolutionModelKeys.approvingPersons,
            type: 'form-array-board-resolution',
            // expressions: { 'props.maxLength': 'formState.maxLength' },
            // hooks: {
            //   onInit: field => {
            //     const form = field.formControl;
            //
            //     return form?.valueChanges
            //       .pipe(
            //         startWith(form?.value),
            //         debounceTime(300),
            //         distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
            //       )
            //       .pipe(
            //         tap(() => {
            //           if (!(form instanceof FormArray) || !Array.isArray(form?.value)) return;
            //
            //           const values: string[] =
            //             form?.value?.map(v => v[BoardResolutionApprovingPersonsModelKeys.personnelUuid])?.filter(Boolean) || [];
            //
            //           const options =
            //             this.authorizedSignatoryOptions$.getValue()?.map(option => {
            //               option.disabled = values.includes(option.value);
            //               return option;
            //             }) ?? [];
            //
            //           if (field.options && field.options.formState) {
            //             field.options.formState = { ...field.options.formState, maxLength: options.length };
            //           }
            //
            //           this.authorizedSignatoryOptions$.next(options);
            //         }),
            //       );
            //   },
            // },
            fieldArray: {
              props: { disabled: true },
              fieldGroup: [
                {
                  key: BoardResolutionApprovingPersonsModelKeys.personnelUuid,
                  type: 'mat-select',
                  props: {
                    options: this.authorizedSignatoryOptions$,
                    required: true,
                  },
                  // expressions: {
                  //   'props.required': ({ parent, options }) => {
                  //     const nonDeletable = options?.formState?.nonDeletable;
                  //     const index = Number(parent?.['index']);
                  //     return Array.isArray(nonDeletable) && !isNaN(index) && nonDeletable.includes(index) && !options?.formState.disabled;
                  //   },
                  // },
                  // hooks: {
                  //   onInit: ({ model, options, form }) => {
                  //     return this.authorizedSignatoryOptions$.pipe(
                  //       distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
                  //       map(asOptions => {
                  //         const personnelUuid = model?.[BoardResolutionApprovingPersonsModelKeys.personnelUuid];
                  //         if (!asOptions.some(o => o.personnel?.metadata?.uuid === personnelUuid)) {
                  //           form?.get(BoardResolutionApprovingPersonsModelKeys.personnelUuid)?.setValue(null);
                  //         }
                  //
                  //         if (options && options.formState) {
                  //           options.formState = { ...options.formState, maxLength: asOptions.length };
                  //         }
                  //       }),
                  //     );
                  //   },
                  // },
                },
              ],
            },
          },
        ],
        // hooks: {
        //   onInit: field => {
        //     const { form, props, model, parent, options } = field;
        //
        //     if (!form) return;
        //
        //     const valueChanges: Observable<unknown> = form.valueChanges.pipe(
        //       startWith(form.value),
        //       distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
        //     );
        //
        //     return combineLatest([valueChanges, this.applicationStore.soleProprietorship$]).pipe(
        //       debounceTime(200),
        //       tap(([, isSoleProprietor]) => {
        //         if (!props || !(model instanceof BoardResolutionModel)) return;
        //
        //         const approvingPersons: PortalFieldConfig | undefined = parent?.get?.(BoardResolutionModelKeys.approvingPersons);
        //
        //         if (approvingPersons?.form instanceof FormArray) {
        //           if (isSoleProprietor) {
        //             approvingPersons?.form.controls.forEach((_, i) => i > 0 && approvingPersons?.props?.remove?.(i));
        //             return;
        //           }
        //         }
        //
        //         const addSignatoryIfNecessary = (requiredCount: number) => {
        //           (!model.approvingPersons || model.approvingPersons.length < requiredCount) && approvingPersons?.props?.add?.();
        //         };
        //
        //         const setNonDeletableFormState = (nonDeletable: number[]) => {
        //           options && (options.formState = { ...options.formState, nonDeletable });
        //         };
        //
        //         switch (model.mode) {
        //           case BoardResolutionMode.ANY_ONE_TO_SIGN:
        //             addSignatoryIfNecessary(1);
        //             setNonDeletableFormState([0]);
        //             break;
        //           case BoardResolutionMode.ANY_TWO_TO_SIGN:
        //             addSignatoryIfNecessary(2);
        //             setNonDeletableFormState([0, 1]);
        //             break;
        //           default:
        //             setNonDeletableFormState([]);
        //             break;
        //         }
        //       }),
        //     );
        //   },
        // },
      },
    ];
  }
}
